import React from 'react';
import ReactDOM from 'react-dom/client';
import Eksamensoppgaver from './Components/Eksamensoppgaver/Eksamensoppgaver';
import setupHeaderAndFooter, {SearchSite} from './utils/setupHeaderAndFooter';
import 'udirsok-index.js'

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render( <Eksamensoppgaver/> );

setupHeaderAndFooter(SearchSite.Eksamensoppgaver);
